import React from 'react';
import { Section } from './ui/Section';
import { Check, X } from 'lucide-react';
export function ForWhoSection() {
  return <Section background="sage" data-id="element-37">
      <div className="text-center mb-8 md:mb-12" data-id="element-38">
        <h2 className="text-2xl md:text-4xl font-serif font-bold text-[#2D2A26] mb-3 md:mb-4" data-id="element-39">
          Para quién es / para quién no es
        </h2>
      </div>

      <div className="grid md:grid-cols-2 gap-4 md:gap-8" data-id="element-40">
        {/* For Who */}
        <div className="bg-white p-5 md:p-8 rounded-2xl shadow-sm border-t-4 border-[#5B7C5B]" data-id="element-41">
          <h3 className="text-xl md:text-2xl font-serif font-bold text-[#5B7C5B] mb-4 md:mb-6" data-id="element-42">
            Es para ti si…
          </h3>
          <ul className="space-y-3 md:space-y-4" data-id="element-43">
            {['Eres mujer 35–45 y la hinchazón te arruina el final del día', 'Quieres una rutina práctica y repetible', 'Prefieres un plan con porciones, calendario y ajustes'].map((item, i) => <li key={i} className="flex items-start" data-id="element-44">
                <Check className="h-5 w-5 text-[#5B7C5B] mt-1 mr-3 flex-shrink-0" data-id="element-45" />
                <span className="text-[#2D2A26]" data-id="element-46">{item}</span>
              </li>)}
          </ul>
        </div>

        {/* Not For Who */}
        <div className="bg-white p-5 md:p-8 rounded-2xl shadow-sm border-t-4 border-[#D4836B]" data-id="element-47">
          <h3 className="text-xl md:text-2xl font-serif font-bold text-[#D4836B] mb-4 md:mb-6" data-id="element-48">
            No es para ti si…
          </h3>
          <ul className="space-y-3 md:space-y-4" data-id="element-49">
            {['Buscas "pierde X kg en X días"', 'Quieres reemplazar todas tus comidas por batidos', 'Tienes una condición médica y buscas tratamiento sin supervisión'].map((item, i) => <li key={i} className="flex items-start" data-id="element-50">
                <X className="h-5 w-5 text-[#D4836B] mt-1 mr-3 flex-shrink-0" data-id="element-51" />
                <span className="text-[#6B6560]" data-id="element-52">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
}